import React from 'react';
import ResetPassword from '../components/ResetPassword';
import action from '../actions/completeNewPassword';

export const context = 'resetPassword';
export class ResetPasswordRoute extends React.PureComponent {
    render() {
        return <ResetPassword context={context} action={action} />;
    }
}

export default ResetPasswordRoute;
